import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCall = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" {...props}>
    <path
      fill="none"
      stroke="#007AFF"
      d="M2.477 1.312c-.468.415-.762.677-.881.785-.666.59-.774 1.425-.323 2.505.676 1.62 3.213 5.526 8.736 8.828 1.219.853 2.314.66 2.816 0 .336-.441.664-.864.986-1.267.358-.55.207-1.06-.451-1.532-.988-.706-.673-.457-1.48-1.008-.807-.551-.8-.428-1.87 0-1.071.428-1.082.8-2.142-.208A78.882 78.882 0 0 1 5.149 6.66c-.414-.388-.414-.872 0-1.451.622-.87.622-1.205 0-2.158a18.063 18.063 0 0 0-1.28-1.738c-.46-.416-.924-.416-1.392 0z"
    />
  </svg>
);
const Memo = memo(SvgCall);
export default Memo;
